// extracted by mini-css-extract-plugin
export default {"container":"MessageInputToolbar_container__Uwgg5","toolbarOperateButton":"MessageInputToolbar_toolbarOperateButton__yujtj","isBoldActive":"MessageInputToolbar_isBoldActive__fkjZi"};